module.exports = __webpack_public_path__ + "static/img/logo_black_icon.9ceeb92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo_black_icon.png
// module id = 2KJg
// module chunks = 36